import { green, red, yellow, blue } from 'theme/theme.constant';
import moment from 'moment';
//JSON ARRAY TO CSV params (data,headings)
export const JSONTOCSV = (data, headingMeta, fileName) => {
	var csv = [];
	let line = '';
	for (let idx in headingMeta) {
		line += headingMeta[idx].title + ',';
	}
	csv.push(line);
	line = '';
	for (let idx in data) {
		for (let jdx in headingMeta) {
			if (data[idx][headingMeta[jdx].key] === null || data[idx][headingMeta[jdx].key] === 'NA') {
				//eslint-disable-next-line
				line += 'NA' + ',';
			} else {
				//eslint-disable-next-line
				line += `${data[idx][headingMeta[jdx].key]}${headingMeta[jdx].unit || ''}` + ',';
			}
		}
		csv.push(line);
		line = '';
	}

	download_csv(csv.join('\n'), `${fileName}.csv`);
};
export const Dom = {
	Class(conditionMap, defaultClass = '') {
		let className = '';
		for (let name in conditionMap) {
			if (conditionMap[name]) className += name + ' ';
		}
		return className + defaultClass;
	},
};

// copy VehicleNo
export const copyVehicleNo = (containerid, e) => {
	e.stopPropagation();
	let r = document.createRange();
	r.selectNode(document.getElementById(containerid));
	window.getSelection().removeAllRanges();
	window.getSelection().addRange(r);
	document.execCommand('copy');
	window.getSelection().removeAllRanges();
};

//Download CSV file
export const download_csv = (csv, filename, callback) => {
	var csvFile;
	var downloadLink;
	csvFile = new Blob([csv], { type: 'text/csv' });
	downloadLink = document.createElement('a');

	downloadLink.download = filename;
	downloadLink.href = window.URL.createObjectURL(csvFile);
	downloadLink.style.display = 'none';
	document.body.appendChild(downloadLink);
	downloadLink.click();
	if (callback) callback();
};

// get SOC Based Color Anywhere
export const getSOCBasedColor = (value) => {
	if (value === null) return '';

	if (value >= 0 && value <= 25) {
		return red[300];
	} else if (value >= 25 && value <= 50) {
		return yellow[300];
	} else if (value >= 50 && value <= 75) {
		return blue[300];
	} else if (value > 100 || value < 0) {
		return '#B4846C';
	} else {
		return green[300];
	}
};

//get Temp Based color

export const getTempBasedColor = (value) => {
	if (value === null) return '';
	if (value >= 0 && value <= 15) {
		return blue[300];
	} else if (value >= 15 && value <= 30) {
		return green[300];
	} else if (value >= 30 && value <= 45) {
		return yellow[300];
	} else if (value > 100 || value < -20) {
		return '#B4846C';
	} else {
		return red[300];
	}
};

//Search JSON Array
export const JSONSearch = (key, data, searchKeys) => {
	let filtered = [];
	for (let idx in data) {
		for (let kdx in searchKeys) {
			if (data[idx][searchKeys[kdx]].toString().toLowerCase().includes(key.toLowerCase())) {
				filtered.push(data[idx]);
			}
		}
	}
	return filtered;
};

//get Hour Min from miliseconds

export const getHourMin = (milisec) => {
	let hourmin = moment.duration(milisec);
	if (hourmin.hours() > 0 && hourmin.minutes() > 0) {
		return `${hourmin.hours()} hr ${hourmin.minutes()} min`;
	} else if (hourmin.hours() === 0 && hourmin.minutes() > 0) {
		return `${hourmin.minutes()} min`;
	} else {
		return `${hourmin.hours()} hr`;
	}
};

//Check Session URL Arguments

export const getURLArgs = (pageKey) => {
	let args = sessionStorage.getItem(pageKey);
	return args === null ? '?autoLoad=false' : args;
};

// update Query Stings

export const updateURLQuery = (key, value, pageKey) => {
	let urlParams = window.location.href.split('?')[1];
	let splittedParam = urlParams.split('&');
	let findParam = splittedParam.filter((param) => param.includes(key));
	if (findParam.length === 0) {
		splittedParam.push(key + '=' + value);
	} else {
		for (let idx in splittedParam) {
			if (splittedParam[idx].includes(key)) {
				let keyValPair = splittedParam[idx].split('=');
				keyValPair[1] = value;
				splittedParam[idx] = keyValPair.join('=');
			}
		}
	}
	sessionStorage.setItem(pageKey, '?' + splittedParam.join('&'));
	// history.push({ pathname: props.path, search: '?' + splittedParam.join('&') });
	return '?' + splittedParam.join('&');
};

export const updateSessionMeta = (key, value, pageKey) => {
	let meta = JSON.parse(sessionStorage.getItem(pageKey));
	if (meta === null) meta = {};
	meta[key] = value;
	sessionStorage.setItem(pageKey, JSON.stringify(meta));
};

export const getTimerange = (type, time) => {
	let todayDate = moment().startOf('day');
	// eslint-disable-next-line
	switch (type) {
		case 'day':
			return {
				starttime: moment(time.endTime).startOf('day').valueOf(),
				endtime: moment(time.endTime).add(1, 'day').startOf('day').valueOf(),
			};
		case 'range':
			return {
				starttime: time.startTime,
				endtime: time.endTime,
			};
		case '1week':
			return {
				starttime: moment().startOf('day').subtract(1, 'week').valueOf(),
				endtime: todayDate.valueOf(),
			};
		case '2week':
			return {
				starttime: moment().startOf('day').subtract(2, 'weeks').valueOf(),
				endtime: todayDate.valueOf(),
			};
		case '3week':
			return {
				starttime: moment().startOf('day').subtract(3, 'weeks').valueOf(),
				endtime: todayDate.valueOf(),
			};
		case 'month':
			return {
				starttime: moment().startOf('day').subtract(1, 'month').valueOf(),
				endtime: todayDate.valueOf(),
			};
	}
};
